import React from "react";
import { Button, Box, CircularProgress } from "@mui/material";
import { colors } from "../assets/colors";

interface ButtonLoadingProps {
  isDelete?: boolean;
  style?: React.CSSProperties;
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  styleLabel?: React.CSSProperties;
  label: string;
  icon?: React.ReactNode;
  color?: string;
}

function ButtonLoading({
  isDelete,
  style,
  loading,
  disabled,
  onClick,
  styleLabel,
  label,
  icon,
  color,
}: ButtonLoadingProps) {
  const defaultStyle = {
    marginTop: "20px",
    width: "100%",
    height: "42px",
    borderRadius: "6px",
    backgroundColor: isDelete ? "white" : colors.primary,
    color: isDelete ? "red" : "white",
    border: isDelete ? "1px solid #ff3c3c" : "none",
  };

  return (
    <Box>
      <Button
        variant={isDelete ? "text" : "contained"}
        style={{
          ...defaultStyle,
          ...style,
          opacity: loading || disabled ? 0.5 : 1,
        }}
        type={onClick ? "button" : "submit"}
        disabled={loading || disabled}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        {icon}
        <span style={styleLabel ? styleLabel : { fontSize: 13 }}>{label}</span>

        {loading && (
          <CircularProgress
            size={24}
            sx={{
              marginLeft: "12px",
              color: color ? color : colors.white,
            }}
          />
        )}
      </Button>
    </Box>
  );
}

export default ButtonLoading;
